import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';


export interface IEarthGlobeIconProps extends ISvgIconProps {

}

export class EarthGlobeIcon extends React.Component<IEarthGlobeIconProps, {}> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g>
                    <path
                        fill="currentColor"
                        d="M12,2A10,10,0,0,0,2.81,8.06l-.12,0,0,.15a10,10,0,0,0,5.51,13A9.88,9.88,0,0,0,12,22,10,10,0,0,0,12,2ZM6.4,19.46A9.33,9.33,0,0,1,3.08,9.27l.27.83a.46.46,0,0,0,.13.18l1.67,1.1-.38.38a.31.31,0,0,0-.1.24v1a.4.4,0,0,0,0,.15l.67,1.33a.35.35,0,0,0,.23.18l1.4.28V18a.27.27,0,0,0,0,.12l.66,1.67A.33.33,0,0,0,7.9,20l1,.33.1,0A.33.33,0,0,0,9.33,20V18.5l1.2-.9a.33.33,0,0,0,.14-.27v-.86l1.23-1.24a.26.26,0,0,0,.09-.17l.34-1.66a.35.35,0,0,0-.26-.4H10.86L10,11.49a.33.33,0,0,0-.28-.16H7.54L7,10.18A.36.36,0,0,0,6.72,10a.33.33,0,0,0-.29.1L6,10.53V10a.33.33,0,0,0-.1-.24l-.56-.57V8.62l2-.29a.29.29,0,0,0,.13-.05l1.66-1a.25.25,0,0,0,.12-.11l.93-1.56.89-.29a.38.38,0,0,0,.21-.22l.33-1a.34.34,0,0,0-.21-.42h0L9.46,3.35l-.34-.23a9.36,9.36,0,0,1,6.41.24l-.61.31H13.67a.33.33,0,0,0-.3.18L12.7,5.18a.34.34,0,0,0,.15.45l0,0,1,.33a.41.41,0,0,0,.19,0l1.24-.31.91.3h0l1.66.34a.36.36,0,0,0,.25,0l.76-.51a9.34,9.34,0,0,1,1,1.34l-1.64.55-1.77-.3-.59-.88a.33.33,0,0,0-.27-.15h-2a.35.35,0,0,0-.24.1l-1,1a.32.32,0,0,0-.09.28l.33,2.34a.32.32,0,0,0,.2.25l2.33,1a.33.33,0,0,0,.22,0l1.19-.3.72.49v1.15a.24.24,0,0,0,0,.15l1.3,2.6v1.25a.34.34,0,0,0,.09.24l.7.7A9.33,9.33,0,0,1,6.4,19.46Z"
                    />
                </g>
            </SvgIcon>
        );
    }
}
